import axios from "axios";

export default axios.create({
  baseURL: "https://esi.evetech.net",
  timeout: 10000
});
